module.exports = __webpack_public_path__ + "media/images/common/backtop_btn_l-420a05ff63296ea9c7bc5ae7406f58d0.png";